// Generated by ReScript, PLEASE EDIT WITH CARE


function importCss(param) {
  return (require(`OrderDashboardAssets/styles/_order-dashboard-main.scss`));
}

function getImage(name) {
  var requireImage = (function(name){
        return require(`OrderDashboardAssets/images/${name}`).default
      });
  return requireImage(name);
}

export {
  importCss ,
  getImage ,
  
}
/* No side effect */
